export const getSelectedEls = (self) => {
  const selection = self._getSelectionThrowable();
  return selection.getSelectedEls();
};
